let colorList = Array.from(document.styleSheets)
  .filter(styleSheet => {
    try {
      return styleSheet.cssRules
    } catch (e) {
      console.warn(e)
      return undefined
    }
  })
  .map(styleSheet => Array.from(styleSheet.cssRules))
  .flat()
  .filter(cssRule => cssRule.name === 'theme')
  .map(styleSheet => Array.from(styleSheet.cssRules))
  .flat()
  .filter(cssRule => cssRule.selectorText.includes(':host') && cssRule.selectorText.includes(':root'))
  .map(cssRule => cssRule.cssText.split('{')[1].split('}')[0].trim().split(';'))
  .flat()
  .map(cssRule => cssRule.trim())
  .filter(cssRule => cssRule.startsWith('--color'))
  .map(cssRule => cssRule.split(': '))
const tempList = colorList.reduce((acc, current) => {
  acc[current[0]] = current[1]
  return acc
}, {})

while (colorList.filter(cssRule => cssRule[1].startsWith('var(--color')).length > 0) {
  colorList = colorList.map((cssRule) => {
    if (!cssRule[1].startsWith('var(--color')) { return cssRule }

    const colorVar = cssRule[1].replace('var(', '').replace(')', '')

    return [cssRule[0], tempList[colorVar]]
  })
}

const regex = /-(?=\d+$)/
const colors = colorList.reduce((acc, current) => {
  current[0] = current[0].replace('--color-', '')
  if (regex.test(current[0])) {
    const name = current[0].split(/-(?=\d+$)/)
    if (acc[name[0]] === undefined) { acc[name[0]] = {} }
    acc[name[0]][name[1]] = current[1]
  } else {
    acc[current[0]] = current[1]
  }

  return acc
}, {})

export default colors
